import { createFileRoute } from "@tanstack/react-router";
import { ScrollTextIcon } from "lucide-react";
import { AuditRetentionSettings } from "@/components/admin/audit/audit-retention-settings";
import { requireAdminSection } from "@/lib/admin-guard";
import { AuditLogView } from "@/ui/components/audit/audit-log-view";

export const Route = createFileRoute("/_admin/audit")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities),
  component: AdminAuditPage,
});

function AdminAuditPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 font-medium text-muted-foreground text-xs uppercase tracking-wider">
          <ScrollTextIcon className="size-3.5" />
          Governance
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading font-semibold text-3xl tracking-tight">Audit logs</h1>
          <p className="max-w-2xl text-muted-foreground text-sm">
            Every recorded action across all workspaces and the platform — logins, data changes,
            exports, and admin operations. Use the filters to narrow by category or search for a
            specific actor or record.
          </p>
        </div>
      </header>

      <section className="flex flex-col gap-3">
        <div className="flex flex-col gap-1">
          <h2 className="font-heading text-xl font-semibold tracking-tight">Retention</h2>
          <p className="max-w-2xl text-muted-foreground text-sm">
            Control how long audit entries are kept and what happens when they age out. A daily
            cleanup applies this policy automatically.
          </p>
        </div>
        <AuditRetentionSettings />
      </section>

      <AuditLogView scope="platform" />
    </div>
  );
}
